import { Box, Flex } from '@/ui';
import { ACCENT, BAR } from './constants';

// Image column left, event rows right — the accent block reads as the hero rather
// than a second list.
export const SideBySideThumbnail = () => (
  <Flex gap="6px" h="full" pt={1} w="full">
    <Box
      bg={ACCENT}
      borderRadius="2px"
      flexShrink={0}
      h="30px"
      opacity={0.6}
      w="34%"
    />
    <Flex direction="column" flex={1} gap="5px">
      {[100, 78, 92, 70].map((width) => (
        <Box bg={BAR} borderRadius="2px" h="5px" key={width} w={`${width}%`} />
      ))}
    </Flex>
  </Flex>
);
